﻿<script>
	import { siteSettings } from "../config";
	import model from "../stores/modelStore";
</script>

<div class="row justify-content-md-center">
	<div class="col-md-8 col-sm-12">
		<h1>Thank You</h1>

		<p>
			Thank you for your enquiry with Shine Lawyers.
		</p>

		<p>Your survey ID is {$model.SurveyReferenceNumber}</p>

		<p>What happens next?</p>

		<ol>
			<li>
				We'd like to speak to you to assess your claim.
			</li>
			<li>
				One of our friendly consultants will be in touch to discuss your situation and confirm next steps.
			</li>
		</ol>

		<p>
			In the meantime if you have any questions, you can contact us on
			{siteSettings.phoneNumber}, or <a
					href="mailto:{siteSettings.emailAddress}"
					title="Email Super {siteSettings.emailAddress}">{siteSettings.emailAddress}</a>.
		</p>
	</div>
</div>
